import TextField from "@mui/material/TextField";
import { ProfileFormData } from "./profile-form-data";
import { FieldError, UseFormRegister } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";

interface Props {
  register: UseFormRegister<ProfileFormData>;
  editMode: boolean;
  notificationEmail: string | null | undefined;
  loginEmail: string | null | undefined;
  fieldError: FieldError | undefined;
  showLoginMail: boolean;
}

export const ProfileEmail = (props: Props) => {
  const { register, editMode, notificationEmail, loginEmail, fieldError, showLoginMail } = props;
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <TextField
        {...register("email")}
        defaultValue={notificationEmail}
        label={t("account.profilePage.notificationEmailLabel")}
        variant="filled"
        //when editMode is false, the field is disabled
        InputProps={{
          readOnly: !editMode,
          style: { backgroundColor: !editMode ? "white" : undefined },
        }}
        error={!!fieldError}
        helperText={fieldError?.message}
        fullWidth
      />

      {showLoginMail && (
        <TextField
          defaultValue={loginEmail}
          label={t("account.profilePage.loginEmailLabel")}
          variant="filled"
          //login email cannot be edited
          InputProps={{
            readOnly: true,
            style: { backgroundColor: !editMode ? "white" : undefined },
          }}
          error={!!fieldError}
          helperText={fieldError?.message}
          fullWidth
        />
      )}
    </Box>
  );
};
